
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("brERQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $cepN4 = parcelRequire("cepN4");


var $ddsLC = parcelRequire("ddsLC");


var $isqha = parcelRequire("isqha");


var $pM2s3 = parcelRequire("pM2s3");

const $db66dcb34355c4eb$var$EMPTY_RESULT = {
    descriptorsByAttachmentId: new Map(),
    status: 'loading',
    actionsByAttachmentId: (0, $pM2s3.EMPTY_ACTIONS_BY_ATTACHMENT_ID)
};
const $db66dcb34355c4eb$var$DiscoveryLoading = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error, onDiscoveryStatusChange: onDiscoveryStatusChange } = t0;
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== onDiscoveryStatusChange) {
        t1 = ()=>{
            if (error) onDiscoveryStatusChange("failure");
        };
        t2 = [
            error,
            onDiscoveryStatusChange
        ];
        $[0] = error;
        $[1] = onDiscoveryStatusChange;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ error: error, onDiscoveryStatusChange: onDiscoveryStatusChange })=>{
    (0, $cozmU.useEffect)(()=>{
        if (error) onDiscoveryStatusChange('failure');
    }, [
        error,
        onDiscoveryStatusChange
    ]);
    return null;
};

const $db66dcb34355c4eb$var$DiscoveryLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "bu5xH",
    name: "DiscoveryLoader",
    loader: async ()=>(await (parcelRequire("7Chvr"))).AttachmentActionEligibilityDiscovery,
    isReactLoadable: true,
    loading: $db66dcb34355c4eb$var$DiscoveryLoading
});
const $db66dcb34355c4eb$var$AttachmentSpecificDiscovery = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db66dcb34355c4eb$var$DiscoveryLoader, props) : null;
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('forge_attachment_display_conditions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db66dcb34355c4eb$var$DiscoveryLoader, props) : null;
const $db66dcb34355c4eb$export$f87801d1dd17ac23 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { children: children, ...props } = t0;
    const { attachmentIds: attachmentIds, content: content, space: space, surface: surface } = props;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const contentAri = props.contentAri ?? (content.id && cloudId ? (0, $isqha.toAttachmentActionAri)(content.id, cloudId, "content") : null);
    let t1;
    if ($[0] !== attachmentIds || $[1] !== cloudId || $[2] !== contentAri || $[3] !== locale || $[4] !== space.id || $[5] !== space.key || $[6] !== surface) {
        t1 = JSON.stringify([
            contentAri,
            attachmentIds,
            cloudId,
            locale,
            space.id,
            space.key,
            surface
        ]);
        $[0] = attachmentIds;
        $[1] = cloudId;
        $[2] = contentAri;
        $[3] = locale;
        $[4] = space.id;
        $[5] = space.key;
        $[6] = surface;
        $[7] = t1;
    } else t1 = $[7];
    const targetKey = t1;
    const [discovery, setDiscovery] = (0, $cozmU.useState)();
    let t2;
    if ($[8] !== targetKey) {
        t2 = (eligibility)=>{
            setDiscovery((current)=>({
                    targetKey: targetKey,
                    result: {
                        ...current?.targetKey === targetKey ? current.result : $db66dcb34355c4eb$var$EMPTY_RESULT,
                        ...eligibility
                    }
                }));
        };
        $[8] = targetKey;
        $[9] = t2;
    } else t2 = $[9];
    const handleEligibility = t2;
    let t3;
    if ($[10] !== targetKey) {
        t3 = (status, successReason)=>{
            setDiscovery((current_0)=>({
                    targetKey: targetKey,
                    result: {
                        ...current_0?.targetKey === targetKey ? current_0.result : $db66dcb34355c4eb$var$EMPTY_RESULT,
                        status: status,
                        successReason: successReason
                    }
                }));
        };
        $[10] = targetKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleStatus = t3;
    let t4;
    if ($[12] !== attachmentIds || $[13] !== content || $[14] !== contentAri || $[15] !== renderServerPlaceholder || $[16] !== space.id || $[17] !== space.key) {
        t4 = !renderServerPlaceholder && contentAri && content.id && content.type && space.id && space.key && attachmentIds.length > 0 && ((0, $9wGTI.fg)("forge_attachment_action_module_metadata") || (0, $9wGTI.fg)("forge_attachment_action"));
        $[12] = attachmentIds;
        $[13] = content;
        $[14] = contentAri;
        $[15] = renderServerPlaceholder;
        $[16] = space.id;
        $[17] = space.key;
        $[18] = t4;
    } else t4 = $[18];
    const enabled = Boolean(t4);
    const result = discovery?.targetKey === targetKey ? discovery.result : $db66dcb34355c4eb$var$EMPTY_RESULT;
    let t5;
    if ($[19] !== result.actionsByAttachmentId || $[20] !== result.status) {
        t5 = result.status === "success" && Array.from(result.actionsByAttachmentId.values()).some($db66dcb34355c4eb$var$_temp);
        $[19] = result.actionsByAttachmentId;
        $[20] = result.status;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== result.status || $[23] !== t5) {
        t6 = {
            status: result.status,
            hasExtensions: t5
        };
        $[22] = result.status;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    const loadState = t6;
    let t7;
    if ($[25] !== attachmentIds || $[26] !== contentAri || $[27] !== enabled || $[28] !== handleEligibility || $[29] !== handleStatus) {
        t7 = enabled && contentAri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db66dcb34355c4eb$var$AttachmentSpecificDiscovery, {
            attachmentIds: attachmentIds,
            contentAri: contentAri,
            onEligibility: handleEligibility,
            onDiscoveryStatusChange: handleStatus
        });
        $[25] = attachmentIds;
        $[26] = contentAri;
        $[27] = enabled;
        $[28] = handleEligibility;
        $[29] = handleStatus;
        $[30] = t7;
    } else t7 = $[30];
    const t8 = enabled && result.status === "success" ? result.actionsByAttachmentId : (0, $pM2s3.EMPTY_ACTIONS_BY_ATTACHMENT_ID);
    let t9;
    if ($[31] !== enabled || $[32] !== loadState) {
        t9 = enabled && (0, $9wGTI.fg)("forge_attachment_display_conditions") && (0, $9wGTI.fg)("forge_attachment_action") ? loadState : (0, $ddsLC.DISABLED_ATTACHMENT_ACTION_LOAD_STATE);
        $[31] = enabled;
        $[32] = loadState;
        $[33] = t9;
    } else t9 = $[33];
    let t10;
    if ($[34] !== children || $[35] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddsLC.AttachmentActionEligibilityLoadStateContext).Provider, {
            value: t9
        }, children);
        $[34] = children;
        $[35] = t9;
        $[36] = t10;
    } else t10 = $[36];
    let t11;
    if ($[37] !== t10 || $[38] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pM2s3.AttachmentActionEligibilityContext).Provider, {
            value: t8
        }, t10);
        $[37] = t10;
        $[38] = t8;
        $[39] = t11;
    } else t11 = $[39];
    let t12;
    if ($[40] !== contentAri || $[41] !== props || $[42] !== result || $[43] !== t11 || $[44] !== t7) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cepN4.AttachmentActionExtensionProvider), {
            ...props,
            contentAri: contentAri,
            attachmentActionEligibilityResult: result
        }, t7, t11);
        $[40] = contentAri;
        $[41] = props;
        $[42] = result;
        $[43] = t11;
        $[44] = t7;
        $[45] = t12;
    } else t12 = $[45];
    return t12;
} : ({ children: children, ...props })=>{
    const { attachmentIds: attachmentIds, content: content, space: space, surface: surface } = props;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const contentAri = props.contentAri ?? (content.id && cloudId ? (0, $isqha.toAttachmentActionAri)(content.id, cloudId, 'content') : null);
    const targetKey = (0, $cozmU.useMemo)(()=>JSON.stringify([
            contentAri,
            attachmentIds,
            cloudId,
            locale,
            space.id,
            space.key,
            surface
        ]), [
        attachmentIds,
        cloudId,
        contentAri,
        locale,
        space.id,
        space.key,
        surface
    ]);
    const [discovery, setDiscovery] = (0, $cozmU.useState)();
    const handleEligibility = (0, $cozmU.useCallback)((eligibility)=>{
        setDiscovery((current)=>({
                targetKey: targetKey,
                result: {
                    ...current?.targetKey === targetKey ? current.result : $db66dcb34355c4eb$var$EMPTY_RESULT,
                    ...eligibility
                }
            }));
    }, [
        targetKey
    ]);
    const handleStatus = (0, $cozmU.useCallback)((status, successReason)=>{
        setDiscovery((current_0)=>({
                targetKey: targetKey,
                result: {
                    ...current_0?.targetKey === targetKey ? current_0.result : $db66dcb34355c4eb$var$EMPTY_RESULT,
                    status: status,
                    successReason: successReason
                }
            }));
    }, [
        targetKey
    ]);
    const enabled = Boolean(!renderServerPlaceholder && contentAri && content.id && content.type && space.id && space.key && attachmentIds.length > 0 && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    ((0, $9wGTI.fg)('forge_attachment_action_module_metadata') || (0, $9wGTI.fg)('forge_attachment_action')));
    const result = discovery?.targetKey === targetKey ? discovery.result : $db66dcb34355c4eb$var$EMPTY_RESULT;
    const loadState = (0, $cozmU.useMemo)(()=>({
            status: result.status,
            hasExtensions: result.status === 'success' && Array.from(result.actionsByAttachmentId.values()).some((actions)=>actions.length > 0)
        }), [
        result
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cepN4.AttachmentActionExtensionProvider), {
        ...props,
        contentAri: contentAri,
        attachmentActionEligibilityResult: result
    }, enabled && contentAri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db66dcb34355c4eb$var$AttachmentSpecificDiscovery, {
        attachmentIds: attachmentIds,
        contentAri: contentAri,
        onEligibility: handleEligibility,
        onDiscoveryStatusChange: handleStatus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pM2s3.AttachmentActionEligibilityContext).Provider, {
        value: enabled && result.status === 'success' ? result.actionsByAttachmentId : (0, $pM2s3.EMPTY_ACTIONS_BY_ATTACHMENT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddsLC.AttachmentActionEligibilityLoadStateContext).Provider, {
        value: // eslint-disable-next-line confluence-feature-gating/no-preconditioning -- Telemetry observes the existing independent action and eligibility gates; it does not introduce feature preconditions.
        enabled && (0, $9wGTI.fg)('forge_attachment_display_conditions') && (0, $9wGTI.fg)('forge_attachment_action') ? loadState : (0, $ddsLC.DISABLED_ATTACHMENT_ACTION_LOAD_STATE)
    }, children)));
};
function $db66dcb34355c4eb$var$_temp(actions) {
    return actions.length > 0;
}
module.exports["AttachmentActionEligibilityProvider"] = $db66dcb34355c4eb$export$f87801d1dd17ac23;

});

parcelRegister("ddsLC", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $9c255f500ad5ea87$export$fdcdcdb27bbfd98a = {
    status: 'disabled',
    hasExtensions: false
};
const $9c255f500ad5ea87$export$73f352b575578733 = (0, $cozmU.createContext)($9c255f500ad5ea87$export$fdcdcdb27bbfd98a);
const $9c255f500ad5ea87$export$3fda5c4accd56ee3 = (0, $cozmU.createContext)($9c255f500ad5ea87$export$fdcdcdb27bbfd98a);
const $9c255f500ad5ea87$export$9fe45583ba65ba54 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const t0 = (0, $cozmU.useContext)($9c255f500ad5ea87$export$73f352b575578733);
    const t1 = (0, $cozmU.useContext)($9c255f500ad5ea87$export$3fda5c4accd56ee3);
    let t2;
    if ($[0] !== t0 || $[1] !== t1) {
        t2 = {
            metadata: t0,
            eligibility: t1
        };
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>({
        metadata: (0, $cozmU.useContext)($9c255f500ad5ea87$export$73f352b575578733),
        eligibility: (0, $cozmU.useContext)($9c255f500ad5ea87$export$3fda5c4accd56ee3)
    });
module.exports["DISABLED_ATTACHMENT_ACTION_LOAD_STATE"] = $9c255f500ad5ea87$export$fdcdcdb27bbfd98a;
module.exports["AttachmentActionMetadataLoadStateContext"] = $9c255f500ad5ea87$export$73f352b575578733;
module.exports["AttachmentActionEligibilityLoadStateContext"] = $9c255f500ad5ea87$export$3fda5c4accd56ee3;
module.exports["useAttachmentActionLoadState"] = $9c255f500ad5ea87$export$9fe45583ba65ba54;

});

parcelRegister("9LMZP", function(module, exports) {

let $71ce827efd6e2664$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71ce827efd6e2664$var$load("bRD1b").then(()=>parcelRequire('4xVId'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("isqha", function(module, exports) {
/** Keep legacy row IDs local; the eligibility endpoint accepts and returns ARIs. */ const $5251b36412a2269a$export$b81580b445ce69ba = (id, cloudId, resourceType)=>{
    if (id.startsWith('ari:')) return id;
    const resourceId = resourceType === 'attachment' ? id.replace(/^att(?=\d+$)/, '') : id;
    return `ari:cloud:confluence:${cloudId}:${resourceType}/${resourceId}`;
};
module.exports["toAttachmentActionAri"] = $5251b36412a2269a$export$b81580b445ce69ba;

});

parcelRegister("pM2s3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

const $ce30881998e3c8d6$export$434db076b22a3904 = new Map();
const $ce30881998e3c8d6$var$EMPTY_ACTIONS = Object.freeze([]);
const $ce30881998e3c8d6$export$1499db7a6d8bab7 = (0, $cozmU.createContext)($ce30881998e3c8d6$export$434db076b22a3904);
const $ce30881998e3c8d6$export$f41e5f19579f0e63 = (0, $3u0dr.isReactCompilerActiveV2)() ? (attachmentId, legacyExtensions)=>{
    const $ = (0, $bDgLe.c)(4);
    const actionsByAttachmentId = (0, $cozmU.useContext)($ce30881998e3c8d6$export$1499db7a6d8bab7);
    if (!(0, $9wGTI.fg)("forge_attachment_action")) return $ce30881998e3c8d6$var$EMPTY_ACTIONS;
    let t0;
    if ($[0] !== actionsByAttachmentId || $[1] !== attachmentId || $[2] !== legacyExtensions) {
        t0 = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? actionsByAttachmentId.get(attachmentId) ?? $ce30881998e3c8d6$var$EMPTY_ACTIONS : legacyExtensions;
        $[0] = actionsByAttachmentId;
        $[1] = attachmentId;
        $[2] = legacyExtensions;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (attachmentId, legacyExtensions)=>{
    const actionsByAttachmentId = (0, $cozmU.useContext)($ce30881998e3c8d6$export$1499db7a6d8bab7);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('forge_attachment_action')) return $ce30881998e3c8d6$var$EMPTY_ACTIONS;
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    return (0, $9wGTI.fg)('forge_attachment_display_conditions') ? actionsByAttachmentId.get(attachmentId) ?? $ce30881998e3c8d6$var$EMPTY_ACTIONS : legacyExtensions;
};
module.exports["EMPTY_ACTIONS_BY_ATTACHMENT_ID"] = $ce30881998e3c8d6$export$434db076b22a3904;
module.exports["AttachmentActionEligibilityContext"] = $ce30881998e3c8d6$export$1499db7a6d8bab7;
module.exports["useEligibleAttachmentActions"] = $ce30881998e3c8d6$export$f41e5f19579f0e63;

});

parcelRegister("7Chvr", function(module, exports) {

let $58b9a961e23f12e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58b9a961e23f12e7$var$load("b8UOT").then(()=>parcelRequire('fzA2H'));

});

parcelRegister("dYoxI", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");

const $9ee9caa430cad4a5$export$86e15f54186ccf2c = (extensions)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('forge_attachment_action')) return [];
    return extensions.filter((extension)=>extension.type === (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION) && extension.properties.location === 'action');
};
const $9ee9caa430cad4a5$export$ba6b222d5f08c0ff = ({ attachmentId: attachmentId, content: content, space: space, surface: surface })=>({
        type: (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION),
        attachment: {
            id: attachmentId
        },
        attachmentActionLocation: 'action',
        content: content,
        space: space,
        surface: surface
    });
module.exports["filterAttachmentActionExtensions"] = $9ee9caa430cad4a5$export$86e15f54186ccf2c;
module.exports["createAttachmentActionExtensionData"] = $9ee9caa430cad4a5$export$ba6b222d5f08c0ff;

});

parcelRegister("eFJfw", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $jYZsR = parcelRequire("jYZsR");


var $cepN4 = parcelRequire("cepN4");


var $2KM5T = parcelRequire("2KM5T");

const $8c213ef2baaa8627$var$CLOSE_GRACE_PERIOD_MS = 200; // Keep the label bold while allowing ADS to own the full appearance palette.
const $8c213ef2baaa8627$var$AttachmentMetadataLozenge = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { appearance: t1, title: title } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "inherit",
            size: "small",
            weight: "bold"
        }, title);
        $[0] = title;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== appearance || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance,
            isBold: true,
            testId: "forge-attachment-action-metadata-lozenge"
        }, t2);
        $[2] = appearance;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ appearance: appearance = 'default', title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true,
        testId: "forge-attachment-action-metadata-lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "inherit",
        size: "small",
        weight: "bold"
    }, title));
const $8c213ef2baaa8627$var$i18n = (0, $kSwu1.defineMessages)({
    loadDetailsError: {
        id: "forge-ui.attachment-action.metadata.load-details-error",
        defaultMessage: "Unable to load attachment details"
    },
    retry: {
        id: "forge-ui.attachment-action.metadata.retry",
        defaultMessage: "Retry"
    }
});
const $8c213ef2baaa8627$var$styles = {
    trigger: "_4FKVYEPgdg _0bjKvDKxmn _3iDTPbccYA _0KLXrujOvk _1ubuxonXvL _34b3D21Y8M _1NDpvb6wH8 _2wtOC9vc3e",
    popupState: "_4c065U8HPE _2Y7lL45zaO",
    retry: "_4FKVYEPgdg _0bjKvDKxmn _23rrnHo10F _4xdlr07p2s _0KLXrujOvk _1UtDYzM7Tp _1ubuxonXvL _34b3D21Y8M _1NDpvb6wH8 _2wtOC9vc3e _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC"
};
const $8c213ef2baaa8627$var$AttachmentActionMetadataPopupLoading = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { descriptor: descriptor, error: error, retry: retry } = t0;
    if (error) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8c213ef2baaa8627$var$i18n.loadDetailsError));
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== retry) {
            t2 = retry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: retry,
                xcss: $8c213ef2baaa8627$var$styles.retry
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8c213ef2baaa8627$var$i18n.retry)) : null;
            $[1] = retry;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                role: "alert",
                xcss: $8c213ef2baaa8627$var$styles.popupState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, t1, t2));
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    let t1;
    if ($[5] !== descriptor.extension.properties.viewportSize) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2KM5T.AttachmentActionMetadataLoading), {
            viewportSize: descriptor.extension.properties.viewportSize
        });
        $[5] = descriptor.extension.properties.viewportSize;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ descriptor: descriptor, error: error, retry: retry })=>{
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "alert",
        xcss: $8c213ef2baaa8627$var$styles.popupState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8c213ef2baaa8627$var$i18n.loadDetailsError)), retry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: retry,
        xcss: $8c213ef2baaa8627$var$styles.retry
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8c213ef2baaa8627$var$i18n.retry)) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2KM5T.AttachmentActionMetadataLoading), {
        viewportSize: descriptor.extension.properties.viewportSize
    });
};

const $8c213ef2baaa8627$var$AttachmentActionMetadataPopupContentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UiESy",
    name: "AttachmentActionMetadataPopupContentLoader",
    loader: async ()=>(await (parcelRequire("6P1Qe"))).AttachmentActionMetadataPopupContent,
    isReactLoadable: true,
    loading: $8c213ef2baaa8627$var$AttachmentActionMetadataPopupLoading
});
const $8c213ef2baaa8627$var$renderPopupErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "alert",
        xcss: $8c213ef2baaa8627$var$styles.popupState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8c213ef2baaa8627$var$i18n.loadDetailsError)));
const $8c213ef2baaa8627$var$AttachmentActionPopupContent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { attachmentId: attachmentId, clearCloseTimer: clearCloseTimer, context: context, descriptor: descriptor, onClose: onClose, onUpdate: onUpdate, popupRef: popupRef, setPopupRef: setPopupRef, scheduleClose: scheduleClose } = t0;
    let t1;
    if ($[0] !== scheduleClose) {
        t1 = (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) scheduleClose();
        };
        $[0] = scheduleClose;
        $[1] = t1;
    } else t1 = $[1];
    const handleBlur = t1;
    let t2;
    if ($[2] !== attachmentId || $[3] !== context || $[4] !== descriptor || $[5] !== onClose || $[6] !== onUpdate) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
            renderOnError: $8c213ef2baaa8627$var$renderPopupErrorFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataPopupContentLoader, {
            attachmentId: attachmentId,
            context: context,
            descriptor: descriptor,
            onClose: onClose,
            onInitialRender: onUpdate
        }));
        $[2] = attachmentId;
        $[3] = context;
        $[4] = descriptor;
        $[5] = onClose;
        $[6] = onUpdate;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== onUpdate || $[9] !== popupRef || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYZsR.ResizeChangeListener), {
            onUpdate: onUpdate,
            popupRef: popupRef
        }, t2);
        $[8] = onUpdate;
        $[9] = popupRef;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== clearCloseTimer || $[13] !== handleBlur || $[14] !== scheduleClose || $[15] !== setPopupRef || $[16] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onBlur: handleBlur,
            onFocus: clearCloseTimer,
            onMouseEnter: clearCloseTimer,
            onMouseLeave: scheduleClose,
            ref: setPopupRef
        }, t3);
        $[12] = clearCloseTimer;
        $[13] = handleBlur;
        $[14] = scheduleClose;
        $[15] = setPopupRef;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ attachmentId: attachmentId, clearCloseTimer: clearCloseTimer, context: context, descriptor: descriptor, onClose: onClose, onUpdate: onUpdate, popupRef: popupRef, setPopupRef: setPopupRef, scheduleClose: scheduleClose })=>{
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) scheduleClose();
    }, [
        scheduleClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onBlur: handleBlur,
        onFocus: clearCloseTimer,
        onMouseEnter: clearCloseTimer,
        onMouseLeave: scheduleClose,
        ref: setPopupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYZsR.ResizeChangeListener), {
        onUpdate: onUpdate,
        popupRef: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
        renderOnError: $8c213ef2baaa8627$var$renderPopupErrorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataPopupContentLoader, {
        attachmentId: attachmentId,
        context: context,
        descriptor: descriptor,
        onClose: onClose,
        onInitialRender: onUpdate
    }))));
};
const $8c213ef2baaa8627$var$AttachmentActionMetadataItem = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { attachmentId: attachmentId, context: context, descriptor: descriptor } = t0;
    const popupKey = `${attachmentId}:${descriptor.extension.id}`;
    const { closePopup: closePopup, openPopup: openPopup } = context;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const closeTimerRef = (0, $cozmU.useRef)(null);
    const isPinnedRef = (0, $cozmU.useRef)(false);
    const suppressFocusOpenRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (closeTimerRef.current) {
                clearTimeout(closeTimerRef.current);
                closeTimerRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearCloseTimer = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            clearCloseTimer();
            suppressFocusOpenRef.current = true;
            isPinnedRef.current = false;
            setIsOpen(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const dismiss = t2;
    let t3;
    if ($[2] !== closePopup || $[3] !== popupKey) {
        t3 = ()=>{
            dismiss();
            closePopup(popupKey);
        };
        $[2] = closePopup;
        $[3] = popupKey;
        $[4] = t3;
    } else t3 = $[4];
    const close = t3;
    let t4;
    if ($[5] !== openPopup || $[6] !== popupKey) {
        t4 = ()=>{
            clearCloseTimer();
            suppressFocusOpenRef.current = false;
            openPopup(popupKey, dismiss);
            setIsOpen(true);
        };
        $[5] = openPopup;
        $[6] = popupKey;
        $[7] = t4;
    } else t4 = $[7];
    const open = t4;
    let t5;
    if ($[8] !== close || $[9] !== popupRef) {
        t5 = ()=>{
            if (isPinnedRef.current) return;
            clearCloseTimer();
            closeTimerRef.current = setTimeout(()=>{
                if (!popupRef?.contains(popupRef.ownerDocument.activeElement)) close();
            }, $8c213ef2baaa8627$var$CLOSE_GRACE_PERIOD_MS);
        };
        $[8] = close;
        $[9] = popupRef;
        $[10] = t5;
    } else t5 = $[10];
    const scheduleClose = t5;
    let t6;
    let t7;
    if ($[11] !== closePopup || $[12] !== popupKey) {
        t6 = ()=>()=>{
                clearCloseTimer();
                closePopup(popupKey);
            };
        t7 = [
            clearCloseTimer,
            closePopup,
            popupKey
        ];
        $[11] = closePopup;
        $[12] = popupKey;
        $[13] = t6;
        $[14] = t7;
    } else {
        t6 = $[13];
        t7 = $[14];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[15] !== isOpen) {
        t8 = ()=>{
            if (!isOpen) {
                isPinnedRef.current = false;
                clearCloseTimer();
            }
        };
        t9 = [
            clearCloseTimer,
            isOpen
        ];
        $[15] = isOpen;
        $[16] = t8;
        $[17] = t9;
    } else {
        t8 = $[16];
        t9 = $[17];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[18] !== isOpen) {
        t10 = ()=>{
            if (isOpen || !suppressFocusOpenRef.current || !(0, $9wGTI.fg)("forge_attachment_metadata_dismiss_fix")) return;
            const allowFocusOpen = (event)=>{
                if (event.key === "Tab") {
                    suppressFocusOpenRef.current = false;
                    document.removeEventListener("keydown", allowFocusOpen, true);
                }
            };
            document.addEventListener("keydown", allowFocusOpen, true);
            return ()=>document.removeEventListener("keydown", allowFocusOpen, true);
        };
        t11 = [
            isOpen
        ];
        $[18] = isOpen;
        $[19] = t10;
        $[20] = t11;
    } else {
        t10 = $[19];
        t11 = $[20];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (!descriptor.hasDetails) {
        let t12;
        if ($[21] !== descriptor.appearance || $[22] !== descriptor.title) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentMetadataLozenge, {
                appearance: descriptor.appearance,
                title: descriptor.title
            });
            $[21] = descriptor.appearance;
            $[22] = descriptor.title;
            $[23] = t12;
        } else t12 = $[23];
        return t12;
    }
    let t12;
    if ($[24] !== close || $[25] !== open) {
        t12 = ()=>{
            if (isPinnedRef.current) {
                close();
                return;
            }
            isPinnedRef.current = true;
            open();
        };
        $[24] = close;
        $[25] = open;
        $[26] = t12;
    } else t12 = $[26];
    const handleClick = t12;
    let t13;
    if ($[27] !== scheduleClose) {
        t13 = (event_0)=>{
            if (!event_0.currentTarget.contains(event_0.relatedTarget)) scheduleClose();
        };
        $[27] = scheduleClose;
        $[28] = t13;
    } else t13 = $[28];
    const handleBlur = t13;
    let t14;
    if ($[29] !== isOpen || $[30] !== open) {
        t14 = ()=>{
            clearCloseTimer();
            if (!isOpen && !suppressFocusOpenRef.current) open();
        };
        $[29] = isOpen;
        $[30] = open;
        $[31] = t14;
    } else t14 = $[31];
    const handleFocus = t14;
    let t15;
    if ($[32] !== close || $[33] !== popupRef) {
        t15 = (event_1)=>{
            if (event_1?.type === "blur" && popupRef?.contains(popupRef.ownerDocument.activeElement)) {
                clearCloseTimer();
                return;
            }
            close();
        };
        $[32] = close;
        $[33] = popupRef;
        $[34] = t15;
    } else t15 = $[34];
    const handlePopupClose = t15;
    let t16;
    if ($[35] !== attachmentId || $[36] !== close || $[37] !== context || $[38] !== descriptor || $[39] !== popupRef || $[40] !== scheduleClose) {
        t16 = (t17)=>{
            const { update: update } = t17;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionPopupContent, {
                attachmentId: attachmentId,
                clearCloseTimer: clearCloseTimer,
                context: context,
                descriptor: descriptor,
                onClose: close,
                onUpdate: update,
                popupRef: popupRef,
                setPopupRef: setPopupRef,
                scheduleClose: scheduleClose
            });
        };
        $[35] = attachmentId;
        $[36] = close;
        $[37] = context;
        $[38] = descriptor;
        $[39] = popupRef;
        $[40] = scheduleClose;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== descriptor.appearance || $[43] !== descriptor.title || $[44] !== handleBlur || $[45] !== handleClick || $[46] !== handleFocus || $[47] !== open || $[48] !== scheduleClose) {
        t17 = (t18)=>{
            const { ref: ref, ...triggerProps } = t18;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                onBlur: handleBlur,
                onClick: handleClick,
                onFocus: (0, $9wGTI.fg)("forge_attachment_metadata_dismiss_fix") ? handleFocus : open,
                onMouseEnter: open,
                onMouseLeave: scheduleClose,
                ref: ref,
                testId: "forge-attachment-action-metadata-trigger",
                xcss: $8c213ef2baaa8627$var$styles.trigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentMetadataLozenge, {
                appearance: descriptor.appearance,
                title: descriptor.title
            }));
        };
        $[42] = descriptor.appearance;
        $[43] = descriptor.title;
        $[44] = handleBlur;
        $[45] = handleClick;
        $[46] = handleFocus;
        $[47] = open;
        $[48] = scheduleClose;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== descriptor.title || $[51] !== handlePopupClose || $[52] !== isOpen || $[53] !== t16 || $[54] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            autoFocus: false,
            content: t16,
            isOpen: isOpen,
            label: descriptor.title,
            onClose: handlePopupClose,
            placement: "bottom-start",
            role: "dialog",
            shouldFitViewport: true,
            shouldRenderToParent: true,
            shouldReturnFocus: true,
            trigger: t17
        });
        $[50] = descriptor.title;
        $[51] = handlePopupClose;
        $[52] = isOpen;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
    } else t18 = $[55];
    return t18;
} : ({ attachmentId: attachmentId, context: context, descriptor: descriptor })=>{
    const popupKey = `${attachmentId}:${descriptor.extension.id}`;
    const { closePopup: closePopup, openPopup: openPopup } = context;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const closeTimerRef = (0, $cozmU.useRef)(null);
    const isPinnedRef = (0, $cozmU.useRef)(false);
    const suppressFocusOpenRef = (0, $cozmU.useRef)(false);
    const clearCloseTimer = (0, $cozmU.useCallback)(()=>{
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
    }, []);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        clearCloseTimer();
        suppressFocusOpenRef.current = true;
        isPinnedRef.current = false;
        setIsOpen(false);
    }, [
        clearCloseTimer
    ]);
    const close = (0, $cozmU.useCallback)(()=>{
        dismiss();
        closePopup(popupKey);
    }, [
        closePopup,
        dismiss,
        popupKey
    ]);
    const open = (0, $cozmU.useCallback)(()=>{
        clearCloseTimer();
        suppressFocusOpenRef.current = false;
        openPopup(popupKey, dismiss);
        setIsOpen(true);
    }, [
        clearCloseTimer,
        dismiss,
        openPopup,
        popupKey
    ]);
    const scheduleClose = (0, $cozmU.useCallback)(()=>{
        if (isPinnedRef.current) return;
        clearCloseTimer();
        closeTimerRef.current = setTimeout(()=>{
            // Focus events inside Custom UI do not bubble out of its iframe. Recheck
            // the parent document after focus settles before honoring a pending blur.
            if (!popupRef?.contains(popupRef.ownerDocument.activeElement)) close();
        }, $8c213ef2baaa8627$var$CLOSE_GRACE_PERIOD_MS);
    }, [
        clearCloseTimer,
        close,
        popupRef
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearCloseTimer();
            closePopup(popupKey);
        }, [
        clearCloseTimer,
        closePopup,
        popupKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            isPinnedRef.current = false;
            clearCloseTimer();
        }
    }, [
        clearCloseTimer,
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isOpen || !suppressFocusOpenRef.current || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Independent rollback requested for the dismissal fix.
        !(0, $9wGTI.fg)('forge_attachment_metadata_dismiss_fix')) return;
         // Restored focus can arrive after close commits. Only fresh keyboard
        // navigation should re-enable focus-opening; hover and click call open directly.
        const allowFocusOpen = (event)=>{
            if (event.key === 'Tab') {
                suppressFocusOpenRef.current = false;
                document.removeEventListener('keydown', allowFocusOpen, true);
            }
        };
        document.addEventListener('keydown', allowFocusOpen, true);
        return ()=>document.removeEventListener('keydown', allowFocusOpen, true);
    }, [
        isOpen
    ]);
    if (!descriptor.hasDetails) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentMetadataLozenge, {
        appearance: descriptor.appearance,
        title: descriptor.title
    });
    const handleClick = ()=>{
        if (isPinnedRef.current) {
            close();
            return;
        }
        isPinnedRef.current = true;
        open();
    };
    const handleBlur = (event_0)=>{
        if (!event_0.currentTarget.contains(event_0.relatedTarget)) scheduleClose();
    };
    const handleFocus = ()=>{
        clearCloseTimer();
        if (!isOpen && !suppressFocusOpenRef.current) open();
    };
    const handlePopupClose = (event_1)=>{
        // ADS also requests dismissal when the window blurs into an iframe. Our
        // Custom UI iframe is inside this popup, so that is an internal interaction.
        if (event_1?.type === 'blur' && popupRef?.contains(popupRef.ownerDocument.activeElement)) {
            clearCloseTimer();
            return;
        }
        close();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        autoFocus: false,
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionPopupContent, {
                attachmentId: attachmentId,
                clearCloseTimer: clearCloseTimer,
                context: context,
                descriptor: descriptor,
                onClose: close,
                onUpdate: update,
                popupRef: popupRef,
                setPopupRef: setPopupRef,
                scheduleClose: scheduleClose
            }),
        isOpen: isOpen,
        label: descriptor.title,
        onClose: handlePopupClose,
        placement: "bottom-start",
        role: "dialog",
        shouldFitViewport: true,
        shouldRenderToParent: true,
        shouldReturnFocus: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                onBlur: handleBlur,
                onClick: handleClick,
                onFocus: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Independent rollback requested for the dismissal fix.
                (0, $9wGTI.fg)('forge_attachment_metadata_dismiss_fix') ? handleFocus : open,
                onMouseEnter: open,
                onMouseLeave: scheduleClose,
                ref: ref,
                testId: "forge-attachment-action-metadata-trigger",
                xcss: $8c213ef2baaa8627$var$styles.trigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentMetadataLozenge, {
                appearance: descriptor.appearance,
                title: descriptor.title
            }))
    });
};
const $8c213ef2baaa8627$export$90412fb0740a86af = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { attachmentId: attachmentId, context: context, descriptors: descriptors } = t0;
    if (descriptors.length === 0) return null;
    let t1;
    if ($[0] !== attachmentId || $[1] !== context || $[2] !== descriptors) {
        let t2;
        if ($[4] !== attachmentId || $[5] !== context) {
            t2 = (descriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataItem, {
                    attachmentId: attachmentId,
                    context: context,
                    descriptor: descriptor,
                    key: descriptor.extension.id
                });
            $[4] = attachmentId;
            $[5] = context;
            $[6] = t2;
        } else t2 = $[6];
        t1 = descriptors.map(t2);
        $[0] = attachmentId;
        $[1] = context;
        $[2] = descriptors;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            shouldWrap: true,
            space: "space.050"
        }, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ attachmentId: attachmentId, context: context, descriptors: descriptors })=>{
    if (descriptors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        shouldWrap: true,
        space: "space.050"
    }, descriptors.map((descriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataItem, {
            attachmentId: attachmentId,
            context: context,
            descriptor: descriptor,
            key: descriptor.extension.id
        })));
};
const $8c213ef2baaa8627$var$AttachmentActionMetadataResolved = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { attachmentId: attachmentId, context: context } = t0;
    let t1;
    if ($[0] !== attachmentId || $[1] !== context.descriptorsByAttachmentId || $[2] !== context.extensions || $[3] !== context.mode) {
        t1 = context.mode === "attachment-specific" ? context.descriptorsByAttachmentId.get(attachmentId) ?? [] : context.extensions;
        $[0] = attachmentId;
        $[1] = context.descriptorsByAttachmentId;
        $[2] = context.extensions;
        $[3] = context.mode;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== attachmentId || $[6] !== context || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$export$90412fb0740a86af, {
            attachmentId: attachmentId,
            context: context,
            descriptors: t1
        });
        $[5] = attachmentId;
        $[6] = context;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ attachmentId: attachmentId, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$export$90412fb0740a86af, {
        attachmentId: attachmentId,
        context: context,
        descriptors: context.mode === 'attachment-specific' ? context.descriptorsByAttachmentId.get(attachmentId) ?? [] : context.extensions
    });
const $8c213ef2baaa8627$export$b9c3be0534fc69af = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { attachmentId: attachmentId } = t0;
    const context = (0, $cepN4.useAttachmentActionExtensionContext)();
    if (!context || typeof attachmentId !== "string" || attachmentId.trim().length === 0) return null;
    let t1;
    if ($[0] !== attachmentId || $[1] !== context) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataResolved, {
            attachmentId: attachmentId,
            context: context
        });
        $[0] = attachmentId;
        $[1] = context;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ attachmentId: attachmentId })=>{
    const context = (0, $cepN4.useAttachmentActionExtensionContext)();
    if (!context || typeof attachmentId !== 'string' || attachmentId.trim().length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c213ef2baaa8627$var$AttachmentActionMetadataResolved, {
        attachmentId: attachmentId,
        context: context
    });
};
module.exports["AttachmentActionMetadata"] = $8c213ef2baaa8627$export$b9c3be0534fc69af;

});

parcelRegister("6P1Qe", function(module, exports) {

let $4f78ef31fc2bd8dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f78ef31fc2bd8dc$var$load("hUbK8"),
    $4f78ef31fc2bd8dc$var$load("LWh5V"),
    $4f78ef31fc2bd8dc$var$load("eRlPy"),
    $4f78ef31fc2bd8dc$var$load("3eyRH"),
    $4f78ef31fc2bd8dc$var$load("5v3VX"),
    $4f78ef31fc2bd8dc$var$load("MeTq1"),
    $4f78ef31fc2bd8dc$var$load("b6eef"),
    $4f78ef31fc2bd8dc$var$load("1Gr4q"),
    $4f78ef31fc2bd8dc$var$load("gP2Y4"),
    $4f78ef31fc2bd8dc$var$load("1iZNo"),
    $4f78ef31fc2bd8dc$var$load("9cVML"),
    $4f78ef31fc2bd8dc$var$load("7G12e"),
    $4f78ef31fc2bd8dc$var$load("4938u"),
    $4f78ef31fc2bd8dc$var$load("15jTz"),
    $4f78ef31fc2bd8dc$var$load("48F3z"),
    $4f78ef31fc2bd8dc$var$load("7SteV"),
    $4f78ef31fc2bd8dc$var$load("4iDo4"),
    $4f78ef31fc2bd8dc$var$load("7klyO"),
    $4f78ef31fc2bd8dc$var$load("dxA9F"),
    $4f78ef31fc2bd8dc$var$load("bkMxV"),
    $4f78ef31fc2bd8dc$var$load("exhLE"),
    $4f78ef31fc2bd8dc$var$load("kQDGR"),
    $4f78ef31fc2bd8dc$var$load("iZR3N"),
    $4f78ef31fc2bd8dc$var$load("jXM1T"),
    $4f78ef31fc2bd8dc$var$load("cvcNg"),
    $4f78ef31fc2bd8dc$var$load("4N1MY"),
    $4f78ef31fc2bd8dc$var$load("5MQ0D"),
    $4f78ef31fc2bd8dc$var$load("i7NGK"),
    $4f78ef31fc2bd8dc$var$load("cIoRg"),
    $4f78ef31fc2bd8dc$var$load("g7vSH"),
    $4f78ef31fc2bd8dc$var$load("jL1Ke"),
    $4f78ef31fc2bd8dc$var$load("fuOfV"),
    $4f78ef31fc2bd8dc$var$load("kHXvF"),
    $4f78ef31fc2bd8dc$var$load("ea3NB"),
    $4f78ef31fc2bd8dc$var$load("6wr18"),
    $4f78ef31fc2bd8dc$var$load("ffEVr"),
    $4f78ef31fc2bd8dc$var$load("59hV4"),
    $4f78ef31fc2bd8dc$var$load("l4j2l"),
    $4f78ef31fc2bd8dc$var$load("37v60"),
    $4f78ef31fc2bd8dc$var$load("cGkFm"),
    $4f78ef31fc2bd8dc$var$load("eF92L"),
    $4f78ef31fc2bd8dc$var$load("jwMHX"),
    $4f78ef31fc2bd8dc$var$load("20wSi"),
    $4f78ef31fc2bd8dc$var$load("bmOOW"),
    $4f78ef31fc2bd8dc$var$load("dDiWc"),
    $4f78ef31fc2bd8dc$var$load("d0ZRF"),
    $4f78ef31fc2bd8dc$var$load("k507P"),
    $4f78ef31fc2bd8dc$var$load("fwbNS"),
    $4f78ef31fc2bd8dc$var$load("gaUhx"),
    $4f78ef31fc2bd8dc$var$load("h4Nf7"),
    $4f78ef31fc2bd8dc$var$load("9TOep"),
    $4f78ef31fc2bd8dc$var$load("bncmK"),
    $4f78ef31fc2bd8dc$var$load("6iTkp"),
    $4f78ef31fc2bd8dc$var$load("hhss7"),
    $4f78ef31fc2bd8dc$var$load("a8R25"),
    $4f78ef31fc2bd8dc$var$load("lnKog"),
    $4f78ef31fc2bd8dc$var$load("aAWLw"),
    $4f78ef31fc2bd8dc$var$load("7EorR"),
    $4f78ef31fc2bd8dc$var$load("fJ8Kj"),
    $4f78ef31fc2bd8dc$var$load("gieFs")
]).then(()=>parcelRequire('dUMav'));

});

parcelRegister("cepN4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $1P7Cq = parcelRequire("1P7Cq");


var $7Ndnw = parcelRequire("7Ndnw");


var $ddsLC = parcelRequire("ddsLC");


var $5Pl0K = parcelRequire("5Pl0K");

const $b145827b9cdf9663$var$EMPTY_DESCRIPTORS = Object.freeze([]);
const $b145827b9cdf9663$var$EMPTY_DESCRIPTORS_BY_ATTACHMENT_ID = new Map();
const $b145827b9cdf9663$var$EMPTY_ATTACHMENT_IDS = Object.freeze([]);
const $b145827b9cdf9663$var$createEmptyDescriptorSelection = (mode)=>mode === 'attachment-specific' ? {
        descriptorsByAttachmentId: $b145827b9cdf9663$var$EMPTY_DESCRIPTORS_BY_ATTACHMENT_ID,
        mode: mode
    } : {
        descriptors: $b145827b9cdf9663$var$EMPTY_DESCRIPTORS,
        mode: mode
    };
const $b145827b9cdf9663$var$AttachmentActionExtensionContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $b145827b9cdf9663$export$908ca5f3fa9de729 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($b145827b9cdf9663$var$AttachmentActionExtensionContext);
} : ()=>(0, $cozmU.useContext)($b145827b9cdf9663$var$AttachmentActionExtensionContext);
const $b145827b9cdf9663$var$isNonEmptyString = (value)=>typeof value === 'string' && value.trim().length > 0;
const $b145827b9cdf9663$var$isConfluenceAri = (value)=>$b145827b9cdf9663$var$isNonEmptyString(value) && value.trim().startsWith('ari:cloud:confluence:');
const $b145827b9cdf9663$var$normalizeAttachmentIds = (attachmentIds)=>{
    if (!attachmentIds) return $b145827b9cdf9663$var$EMPTY_ATTACHMENT_IDS;
    return Array.from(new Set(attachmentIds.flatMap((attachmentId)=>$b145827b9cdf9663$var$isNonEmptyString(attachmentId) ? [
            attachmentId.trim()
        ] : [])));
};
const $b145827b9cdf9663$var$resolveProviderContext = ({ content: content, space: space, surface: surface })=>{
    if (!$b145827b9cdf9663$var$isNonEmptyString(content.id) || !$b145827b9cdf9663$var$isNonEmptyString(content.type) || !$b145827b9cdf9663$var$isNonEmptyString(space.id) || !$b145827b9cdf9663$var$isNonEmptyString(space.key) || surface !== 'attachmentPage' && surface !== 'attachmentMacro') return null;
    return {
        type: (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION),
        attachmentActionLocation: 'metadata',
        content: {
            id: content.id,
            type: content.type,
            ...content.subtype !== undefined ? {
                subtype: content.subtype
            } : {}
        },
        space: {
            id: space.id,
            key: space.key
        },
        surface: surface
    };
};
const $b145827b9cdf9663$var$renderDiscoveryErrorFallback = ()=>null;
const $b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryUnconditionalLoading = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { error: error, onDescriptors: onDescriptors, onDiscoveryStatusChange: onDiscoveryStatusChange } = t0;
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== onDescriptors || $[2] !== onDiscoveryStatusChange) {
        t1 = ()=>{
            if (error) {
                onDescriptors($b145827b9cdf9663$var$EMPTY_DESCRIPTORS);
                onDiscoveryStatusChange("failure");
            }
        };
        t2 = [
            error,
            onDescriptors,
            onDiscoveryStatusChange
        ];
        $[0] = error;
        $[1] = onDescriptors;
        $[2] = onDiscoveryStatusChange;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ error: error, onDescriptors: onDescriptors, onDiscoveryStatusChange: onDiscoveryStatusChange })=>{
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            onDescriptors($b145827b9cdf9663$var$EMPTY_DESCRIPTORS);
            onDiscoveryStatusChange('failure');
        }
    }, [
        error,
        onDescriptors,
        onDiscoveryStatusChange
    ]);
    return null;
};
const $b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryLoading = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryUnconditionalLoading, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryUnconditionalLoading, props);

const $b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PwI8Z",
    name: "AttachmentActionExtensionDiscoveryLoader",
    loader: async ()=>(await (parcelRequire("9LMZP"))).AttachmentActionExtensionDiscovery,
    isReactLoadable: true,
    loading: $b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryLoading
});
const $b145827b9cdf9663$var$createDiscoveryState = (contextKey, generation, mode)=>({
        contextKey: contextKey,
        descriptorSelection: $b145827b9cdf9663$var$createEmptyDescriptorSelection(mode),
        generation: generation,
        status: 'loading'
    });
const $b145827b9cdf9663$var$AttachmentActionExtensionProviderState = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    const { attachmentActionEligibilityResult: attachmentActionEligibilityResult, children: children, contextKey: contextKey, enabled: enabled, mode: mode, providerContext: providerContext, surface: surface } = t0;
    const participantId = (0, $cozmU.useId)();
    const activeContextKey = enabled ? contextKey : null;
    let t1;
    if ($[0] !== mode) {
        t1 = ()=>$b145827b9cdf9663$var$createDiscoveryState(null, 0, mode);
        $[0] = mode;
        $[1] = t1;
    } else t1 = $[1];
    const [discoveryState, setDiscoveryState] = (0, $cozmU.useState)(t1);
    const activePopupRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const activePopup = activePopupRef.current;
            activePopupRef.current = null;
            activePopup?.dismiss();
        };
        $[2] = t2;
    } else t2 = $[2];
    const closeActivePopup = t2;
    let t3;
    let t4;
    if ($[3] !== activeContextKey || $[4] !== mode) {
        t3 = ()=>{
            closeActivePopup();
            setDiscoveryState((currentState)=>{
                if (currentState.contextKey === activeContextKey) return currentState;
                return $b145827b9cdf9663$var$createDiscoveryState(activeContextKey, currentState.generation + 1, mode);
            });
            return closeActivePopup;
        };
        t4 = [
            activeContextKey,
            closeActivePopup,
            mode
        ];
        $[3] = activeContextKey;
        $[4] = mode;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (popupKey, dismiss)=>{
            const activePopup_0 = activePopupRef.current;
            if (activePopup_0?.popupKey !== popupKey) activePopup_0?.dismiss();
            activePopupRef.current = {
                dismiss: dismiss,
                popupKey: popupKey
            };
        };
        $[7] = t5;
    } else t5 = $[7];
    const openPopup = t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (popupKey_0)=>{
            if (activePopupRef.current?.popupKey === popupKey_0) activePopupRef.current = null;
        };
        $[8] = t6;
    } else t6 = $[8];
    const closePopup = t6;
    const isCurrentGeneration = discoveryState.contextKey === activeContextKey;
    const isExternalAttachmentSpecificDiscovery = mode === "attachment-specific" && attachmentActionEligibilityResult !== undefined;
    const experienceStatus = isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.status : isCurrentGeneration ? discoveryState.status : "loading";
    const t7 = enabled && activeContextKey !== null;
    let t8;
    if ($[9] !== attachmentActionEligibilityResult || $[10] !== discoveryState.successReason || $[11] !== experienceStatus || $[12] !== isExternalAttachmentSpecificDiscovery) {
        t8 = experienceStatus === "success" && (isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.successReason : discoveryState.successReason) ? {
            successReason: isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.successReason : discoveryState.successReason
        } : {};
        $[9] = attachmentActionEligibilityResult;
        $[10] = discoveryState.successReason;
        $[11] = experienceStatus;
        $[12] = isExternalAttachmentSpecificDiscovery;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== activeContextKey || $[15] !== experienceStatus || $[16] !== participantId || $[17] !== surface || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            discoveryKey: activeContextKey,
            enabled: t7,
            participantId: participantId,
            status: experienceStatus,
            ...t8,
            surface: surface
        };
        $[14] = activeContextKey;
        $[15] = experienceStatus;
        $[16] = participantId;
        $[17] = surface;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    (0, $5Pl0K.useAttachmentActionDiscoveryExperience)(t9);
    const { generation: generation } = discoveryState;
    let t10;
    if ($[21] !== activeContextKey || $[22] !== generation) {
        t10 = (descriptors)=>{
            setDiscoveryState((currentState_0)=>{
                if (currentState_0.contextKey !== activeContextKey || currentState_0.generation !== generation || currentState_0.descriptorSelection.mode !== "unconditional" || currentState_0.descriptorSelection.descriptors === descriptors) return currentState_0;
                return {
                    ...currentState_0,
                    descriptorSelection: {
                        descriptors: descriptors,
                        mode: "unconditional"
                    }
                };
            });
        };
        $[21] = activeContextKey;
        $[22] = generation;
        $[23] = t10;
    } else t10 = $[23];
    const handleDescriptors = t10;
    let t11;
    if ($[24] !== activeContextKey || $[25] !== generation) {
        t11 = (status, successReason)=>{
            setDiscoveryState((currentState_1)=>{
                if (currentState_1.contextKey !== activeContextKey || currentState_1.generation !== generation) return currentState_1;
                const nextSuccessReason = status === "success" ? successReason : undefined;
                const shouldClearDescriptors = status !== "success";
                const descriptorsAreAlreadyEmpty = currentState_1.descriptorSelection.mode === "attachment-specific" ? currentState_1.descriptorSelection.descriptorsByAttachmentId === $b145827b9cdf9663$var$EMPTY_DESCRIPTORS_BY_ATTACHMENT_ID : currentState_1.descriptorSelection.descriptors === $b145827b9cdf9663$var$EMPTY_DESCRIPTORS;
                if (currentState_1.status === status && currentState_1.successReason === nextSuccessReason && (!shouldClearDescriptors || descriptorsAreAlreadyEmpty)) return currentState_1;
                const { successReason: _currentSuccessReason, ...stateWithoutSuccessReason } = currentState_1;
                return {
                    ...stateWithoutSuccessReason,
                    descriptorSelection: shouldClearDescriptors ? $b145827b9cdf9663$var$createEmptyDescriptorSelection(currentState_1.descriptorSelection.mode) : currentState_1.descriptorSelection,
                    status: status,
                    ...nextSuccessReason ? {
                        successReason: nextSuccessReason
                    } : {}
                };
            });
        };
        $[24] = activeContextKey;
        $[25] = generation;
        $[26] = t11;
    } else t11 = $[26];
    const handleDiscoveryStatusChange = t11;
    let t12;
    if ($[27] !== handleDiscoveryStatusChange) {
        t12 = ()=>{
            handleDiscoveryStatusChange("failure");
        };
        $[27] = handleDiscoveryStatusChange;
        $[28] = t12;
    } else t12 = $[28];
    const handleDiscoveryFailure = t12;
    let t13;
    bb0: {
        if (isExternalAttachmentSpecificDiscovery) {
            let t14;
            if ($[29] !== attachmentActionEligibilityResult.descriptorsByAttachmentId || $[30] !== attachmentActionEligibilityResult.status || $[31] !== mode) {
                t14 = attachmentActionEligibilityResult.status === "success" ? {
                    descriptorsByAttachmentId: attachmentActionEligibilityResult.descriptorsByAttachmentId,
                    mode: "attachment-specific"
                } : $b145827b9cdf9663$var$createEmptyDescriptorSelection(mode);
                $[29] = attachmentActionEligibilityResult.descriptorsByAttachmentId;
                $[30] = attachmentActionEligibilityResult.status;
                $[31] = mode;
                $[32] = t14;
            } else t14 = $[32];
            t13 = t14;
            break bb0;
        }
        let t14;
        if ($[33] !== discoveryState.descriptorSelection || $[34] !== discoveryState.status || $[35] !== enabled || $[36] !== isCurrentGeneration || $[37] !== mode) {
            t14 = enabled && isCurrentGeneration && discoveryState.status === "success" ? discoveryState.descriptorSelection : $b145827b9cdf9663$var$createEmptyDescriptorSelection(mode);
            $[33] = discoveryState.descriptorSelection;
            $[34] = discoveryState.status;
            $[35] = enabled;
            $[36] = isCurrentGeneration;
            $[37] = mode;
            $[38] = t14;
        } else t14 = $[38];
        t13 = t14;
    }
    const activeDescriptorSelection = t13;
    let t14;
    if ($[39] !== activeDescriptorSelection.descriptors || $[40] !== activeDescriptorSelection.descriptorsByAttachmentId || $[41] !== activeDescriptorSelection.mode) {
        t14 = activeDescriptorSelection.mode === "attachment-specific" ? Array.from(activeDescriptorSelection.descriptorsByAttachmentId.values()).some($b145827b9cdf9663$var$_temp) : activeDescriptorSelection.descriptors.length > 0;
        $[39] = activeDescriptorSelection.descriptors;
        $[40] = activeDescriptorSelection.descriptorsByAttachmentId;
        $[41] = activeDescriptorSelection.mode;
        $[42] = t14;
    } else t14 = $[42];
    const hasActiveDescriptors = t14;
    const t15 = enabled ? experienceStatus : "disabled";
    const t16 = enabled && hasActiveDescriptors;
    let t17;
    if ($[43] !== t15 || $[44] !== t16) {
        t17 = {
            status: t15,
            hasExtensions: t16
        };
        $[43] = t15;
        $[44] = t16;
        $[45] = t17;
    } else t17 = $[45];
    const loadState = t17;
    let t18;
    if ($[46] !== activeDescriptorSelection.descriptors || $[47] !== activeDescriptorSelection.descriptorsByAttachmentId || $[48] !== activeDescriptorSelection.mode || $[49] !== enabled || $[50] !== hasActiveDescriptors || $[51] !== providerContext) {
        t18 = enabled && providerContext && hasActiveDescriptors ? {
            ...providerContext,
            closePopup: closePopup,
            openPopup: openPopup,
            ...activeDescriptorSelection.mode === "attachment-specific" ? {
                descriptorsByAttachmentId: activeDescriptorSelection.descriptorsByAttachmentId,
                mode: "attachment-specific"
            } : {
                extensions: activeDescriptorSelection.descriptors,
                mode: "unconditional"
            }
        } : null;
        $[46] = activeDescriptorSelection.descriptors;
        $[47] = activeDescriptorSelection.descriptorsByAttachmentId;
        $[48] = activeDescriptorSelection.mode;
        $[49] = enabled;
        $[50] = hasActiveDescriptors;
        $[51] = providerContext;
        $[52] = t18;
    } else t18 = $[52];
    const contextValue = t18;
    let t19;
    if ($[53] !== children || $[54] !== loadState) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddsLC.AttachmentActionMetadataLoadStateContext).Provider, {
            value: loadState
        }, children);
        $[53] = children;
        $[54] = loadState;
        $[55] = t19;
    } else t19 = $[55];
    let t20;
    if ($[56] !== activeContextKey || $[57] !== enabled || $[58] !== generation || $[59] !== handleDescriptors || $[60] !== handleDiscoveryFailure || $[61] !== handleDiscoveryStatusChange || $[62] !== isCurrentGeneration || $[63] !== mode || $[64] !== providerContext) {
        t20 = enabled && providerContext && activeContextKey && isCurrentGeneration && mode === "unconditional" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
            key: `${activeContextKey}:${generation}`,
            onError: handleDiscoveryFailure,
            renderOnError: $b145827b9cdf9663$var$renderDiscoveryErrorFallback
        }, mode === "unconditional" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryLoader, {
            contentId: providerContext.content.id,
            key: `${activeContextKey}:${generation}`,
            mode: "unconditional",
            onDescriptors: handleDescriptors,
            onDiscoveryStatusChange: handleDiscoveryStatusChange,
            spaceKey: providerContext.space.key,
            surface: providerContext.surface
        }) : null) : null;
        $[56] = activeContextKey;
        $[57] = enabled;
        $[58] = generation;
        $[59] = handleDescriptors;
        $[60] = handleDiscoveryFailure;
        $[61] = handleDiscoveryStatusChange;
        $[62] = isCurrentGeneration;
        $[63] = mode;
        $[64] = providerContext;
        $[65] = t20;
    } else t20 = $[65];
    let t21;
    if ($[66] !== contextValue || $[67] !== t19 || $[68] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionContext.Provider, {
            value: contextValue
        }, t19, t20);
        $[66] = contextValue;
        $[67] = t19;
        $[68] = t20;
        $[69] = t21;
    } else t21 = $[69];
    return t21;
} : ({ attachmentActionEligibilityResult: attachmentActionEligibilityResult, children: children, contextKey: contextKey, enabled: enabled, mode: mode, providerContext: providerContext, surface: surface })=>{
    const participantId = (0, $cozmU.useId)();
    const activeContextKey = enabled ? contextKey : null;
    const [discoveryState, setDiscoveryState] = (0, $cozmU.useState)(()=>$b145827b9cdf9663$var$createDiscoveryState(null, 0, mode));
    const activePopupRef = (0, $cozmU.useRef)(null);
    const closeActivePopup = (0, $cozmU.useCallback)(()=>{
        const activePopup = activePopupRef.current;
        activePopupRef.current = null;
        activePopup?.dismiss();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        closeActivePopup();
        setDiscoveryState((currentState)=>{
            if (currentState.contextKey === activeContextKey) return currentState;
            return $b145827b9cdf9663$var$createDiscoveryState(activeContextKey, currentState.generation + 1, mode);
        });
        return closeActivePopup;
    }, [
        activeContextKey,
        closeActivePopup,
        mode
    ]);
    const openPopup = (0, $cozmU.useCallback)((popupKey, dismiss)=>{
        const activePopup_0 = activePopupRef.current;
        if (activePopup_0?.popupKey !== popupKey) activePopup_0?.dismiss();
        activePopupRef.current = {
            dismiss: dismiss,
            popupKey: popupKey
        };
    }, []);
    const closePopup = (0, $cozmU.useCallback)((popupKey_0)=>{
        if (activePopupRef.current?.popupKey === popupKey_0) activePopupRef.current = null;
    }, []);
    const isCurrentGeneration = discoveryState.contextKey === activeContextKey;
    const isExternalAttachmentSpecificDiscovery = mode === 'attachment-specific' && attachmentActionEligibilityResult !== undefined;
    const experienceStatus = isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.status : isCurrentGeneration ? discoveryState.status : 'loading';
    (0, $5Pl0K.useAttachmentActionDiscoveryExperience)({
        discoveryKey: activeContextKey,
        enabled: enabled && activeContextKey !== null,
        participantId: participantId,
        status: experienceStatus,
        ...experienceStatus === 'success' && (isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.successReason : discoveryState.successReason) ? {
            successReason: isExternalAttachmentSpecificDiscovery ? attachmentActionEligibilityResult.successReason : discoveryState.successReason
        } : {},
        surface: surface
    });
    const { generation: generation } = discoveryState;
    const handleDescriptors = (0, $cozmU.useCallback)((descriptors)=>{
        setDiscoveryState((currentState_0)=>{
            if (currentState_0.contextKey !== activeContextKey || currentState_0.generation !== generation || currentState_0.descriptorSelection.mode !== 'unconditional' || currentState_0.descriptorSelection.descriptors === descriptors) return currentState_0;
            return {
                ...currentState_0,
                descriptorSelection: {
                    descriptors: descriptors,
                    mode: 'unconditional'
                }
            };
        });
    }, [
        activeContextKey,
        generation
    ]);
    const handleDiscoveryStatusChange = (0, $cozmU.useCallback)((status, successReason)=>{
        setDiscoveryState((currentState_1)=>{
            if (currentState_1.contextKey !== activeContextKey || currentState_1.generation !== generation) return currentState_1;
            const nextSuccessReason = status === 'success' ? successReason : undefined;
            const shouldClearDescriptors = status !== 'success';
            const descriptorsAreAlreadyEmpty = currentState_1.descriptorSelection.mode === 'attachment-specific' ? currentState_1.descriptorSelection.descriptorsByAttachmentId === $b145827b9cdf9663$var$EMPTY_DESCRIPTORS_BY_ATTACHMENT_ID : currentState_1.descriptorSelection.descriptors === $b145827b9cdf9663$var$EMPTY_DESCRIPTORS;
            if (currentState_1.status === status && currentState_1.successReason === nextSuccessReason && (!shouldClearDescriptors || descriptorsAreAlreadyEmpty)) return currentState_1;
            const { successReason: _currentSuccessReason, ...stateWithoutSuccessReason } = currentState_1;
            return {
                ...stateWithoutSuccessReason,
                descriptorSelection: shouldClearDescriptors ? $b145827b9cdf9663$var$createEmptyDescriptorSelection(currentState_1.descriptorSelection.mode) : currentState_1.descriptorSelection,
                status: status,
                ...nextSuccessReason ? {
                    successReason: nextSuccessReason
                } : {}
            };
        });
    }, [
        activeContextKey,
        generation
    ]);
    const handleDiscoveryFailure = (0, $cozmU.useCallback)(()=>{
        handleDiscoveryStatusChange('failure');
    }, [
        handleDiscoveryStatusChange
    ]);
    const activeDescriptorSelection = (0, $cozmU.useMemo)(()=>{
        if (isExternalAttachmentSpecificDiscovery) return attachmentActionEligibilityResult.status === 'success' ? {
            descriptorsByAttachmentId: attachmentActionEligibilityResult.descriptorsByAttachmentId,
            mode: 'attachment-specific'
        } : $b145827b9cdf9663$var$createEmptyDescriptorSelection(mode);
        return enabled && isCurrentGeneration && discoveryState.status === 'success' ? discoveryState.descriptorSelection : $b145827b9cdf9663$var$createEmptyDescriptorSelection(mode);
    }, [
        attachmentActionEligibilityResult,
        discoveryState.descriptorSelection,
        discoveryState.status,
        enabled,
        isCurrentGeneration,
        isExternalAttachmentSpecificDiscovery,
        mode
    ]);
    const hasActiveDescriptors = activeDescriptorSelection.mode === 'attachment-specific' ? Array.from(activeDescriptorSelection.descriptorsByAttachmentId.values()).some((descriptors_0)=>descriptors_0.length > 0) : activeDescriptorSelection.descriptors.length > 0;
    const loadState = (0, $cozmU.useMemo)(()=>({
            status: enabled ? experienceStatus : 'disabled',
            hasExtensions: enabled && hasActiveDescriptors
        }), [
        enabled,
        experienceStatus,
        hasActiveDescriptors
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>enabled && providerContext && hasActiveDescriptors ? {
            ...providerContext,
            closePopup: closePopup,
            openPopup: openPopup,
            ...activeDescriptorSelection.mode === 'attachment-specific' ? {
                descriptorsByAttachmentId: activeDescriptorSelection.descriptorsByAttachmentId,
                mode: 'attachment-specific'
            } : {
                extensions: activeDescriptorSelection.descriptors,
                mode: 'unconditional'
            }
        } : null, [
        activeDescriptorSelection,
        closePopup,
        enabled,
        hasActiveDescriptors,
        openPopup,
        providerContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddsLC.AttachmentActionMetadataLoadStateContext).Provider, {
        value: loadState
    }, children), enabled && providerContext && activeContextKey && isCurrentGeneration && mode === 'unconditional' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
        key: `${activeContextKey}:${generation}`,
        onError: handleDiscoveryFailure,
        renderOnError: $b145827b9cdf9663$var$renderDiscoveryErrorFallback
    }, mode === 'unconditional' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionDiscoveryLoader, {
        contentId: providerContext.content.id,
        key: `${activeContextKey}:${generation}`,
        mode: "unconditional",
        onDescriptors: handleDescriptors,
        onDiscoveryStatusChange: handleDiscoveryStatusChange,
        spaceKey: providerContext.space.key,
        surface: providerContext.surface
    }) : null) : null);
};
const $b145827b9cdf9663$export$3201888aa75d93eb = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { attachmentIds: attachmentIds, attachmentActionEligibilityResult: attachmentActionEligibilityResult, children: children, content: content, contentAri: contentAri, space: space, surface: surface } = t0;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { id: contentId, subtype: contentSubtype, type: contentType } = content;
    const { id: spaceId, key: spaceKey } = space;
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubtype || $[2] !== contentType || $[3] !== spaceId || $[4] !== spaceKey || $[5] !== surface) {
        t1 = $b145827b9cdf9663$var$resolveProviderContext({
            content: {
                id: contentId,
                subtype: contentSubtype,
                type: contentType
            },
            space: {
                id: spaceId,
                key: spaceKey
            },
            surface: surface
        });
        $[0] = contentId;
        $[1] = contentSubtype;
        $[2] = contentType;
        $[3] = spaceId;
        $[4] = spaceKey;
        $[5] = surface;
        $[6] = t1;
    } else t1 = $[6];
    const providerContext = t1;
    let t2;
    if ($[7] !== attachmentIds) {
        t2 = $b145827b9cdf9663$var$normalizeAttachmentIds(attachmentIds);
        $[7] = attachmentIds;
        $[8] = t2;
    } else t2 = $[8];
    const normalizedAttachmentIds = t2;
    let t3;
    if ($[9] !== contentAri) {
        t3 = $b145827b9cdf9663$var$isConfluenceAri(contentAri) ? contentAri.trim() : null;
        $[9] = contentAri;
        $[10] = t3;
    } else t3 = $[10];
    const normalizedContentAri = t3;
    let t4;
    if ($[11] !== providerContext) {
        t4 = providerContext ? JSON.stringify([
            "unconditional",
            providerContext.surface,
            providerContext.content.id,
            providerContext.space.id,
            providerContext.space.key
        ]) : null;
        $[11] = providerContext;
        $[12] = t4;
    } else t4 = $[12];
    const unconditionalContextKey = t4;
    let t5;
    if ($[13] !== normalizedAttachmentIds || $[14] !== normalizedContentAri || $[15] !== providerContext) {
        t5 = providerContext && normalizedContentAri && normalizedAttachmentIds.length > 0 ? JSON.stringify([
            "attachment-specific",
            providerContext.surface,
            normalizedContentAri,
            ...normalizedAttachmentIds
        ]) : null;
        $[13] = normalizedAttachmentIds;
        $[14] = normalizedContentAri;
        $[15] = providerContext;
        $[16] = t5;
    } else t5 = $[16];
    const attachmentSpecificContextKey = t5;
    if (renderServerPlaceholder || providerContext === null || !(0, $9wGTI.fg)("forge_attachment_action_module_metadata")) {
        let t6;
        if ($[17] !== children || $[18] !== providerContext || $[19] !== surface) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
                attachmentActionEligibilityResult: undefined,
                contextKey: null,
                enabled: false,
                mode: "unconditional",
                providerContext: providerContext,
                surface: surface
            }, children);
            $[17] = children;
            $[18] = providerContext;
            $[19] = surface;
            $[20] = t6;
        } else t6 = $[20];
        return t6;
    }
    if ((0, $9wGTI.fg)("forge_attachment_display_conditions")) {
        const t6 = attachmentSpecificContextKey !== null;
        let t7;
        if ($[21] !== attachmentActionEligibilityResult || $[22] !== attachmentSpecificContextKey || $[23] !== children || $[24] !== providerContext || $[25] !== surface || $[26] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
                attachmentActionEligibilityResult: attachmentActionEligibilityResult,
                contextKey: attachmentSpecificContextKey,
                enabled: t6,
                mode: "attachment-specific",
                providerContext: providerContext,
                surface: surface
            }, children);
            $[21] = attachmentActionEligibilityResult;
            $[22] = attachmentSpecificContextKey;
            $[23] = children;
            $[24] = providerContext;
            $[25] = surface;
            $[26] = t6;
            $[27] = t7;
        } else t7 = $[27];
        return t7;
    }
    let t6;
    if ($[28] !== children || $[29] !== providerContext || $[30] !== surface || $[31] !== unconditionalContextKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
            attachmentActionEligibilityResult: undefined,
            contextKey: unconditionalContextKey,
            enabled: true,
            mode: "unconditional",
            providerContext: providerContext,
            surface: surface
        }, children);
        $[28] = children;
        $[29] = providerContext;
        $[30] = surface;
        $[31] = unconditionalContextKey;
        $[32] = t6;
    } else t6 = $[32];
    return t6;
} : ({ attachmentIds: attachmentIds, attachmentActionEligibilityResult: attachmentActionEligibilityResult, children: children, content: content, contentAri: contentAri, space: space, surface: surface })=>{
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { id: contentId, subtype: contentSubtype, type: contentType } = content;
    const { id: spaceId, key: spaceKey } = space;
    const providerContext = (0, $cozmU.useMemo)(()=>$b145827b9cdf9663$var$resolveProviderContext({
            content: {
                id: contentId,
                subtype: contentSubtype,
                type: contentType
            },
            space: {
                id: spaceId,
                key: spaceKey
            },
            surface: surface
        }), [
        contentId,
        contentSubtype,
        contentType,
        spaceId,
        spaceKey,
        surface
    ]);
    const normalizedAttachmentIds = (0, $cozmU.useMemo)(()=>$b145827b9cdf9663$var$normalizeAttachmentIds(attachmentIds), [
        attachmentIds
    ]);
    const normalizedContentAri = $b145827b9cdf9663$var$isConfluenceAri(contentAri) ? contentAri.trim() : null;
    const unconditionalContextKey = (0, $cozmU.useMemo)(()=>providerContext ? JSON.stringify([
            'unconditional',
            providerContext.surface,
            providerContext.content.id,
            providerContext.space.id,
            providerContext.space.key
        ]) : null, [
        providerContext
    ]);
    const attachmentSpecificContextKey = (0, $cozmU.useMemo)(()=>providerContext && normalizedContentAri && normalizedAttachmentIds.length > 0 ? JSON.stringify([
            'attachment-specific',
            providerContext.surface,
            normalizedContentAri,
            ...normalizedAttachmentIds
        ]) : null, [
        normalizedAttachmentIds,
        normalizedContentAri,
        providerContext
    ]);
    if (renderServerPlaceholder || providerContext === null || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    !(0, $9wGTI.fg)('forge_attachment_action_module_metadata')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
        attachmentActionEligibilityResult: undefined,
        contextKey: null,
        enabled: false,
        mode: "unconditional",
        providerContext: providerContext,
        surface: surface
    }, children);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('forge_attachment_display_conditions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
        attachmentActionEligibilityResult: attachmentActionEligibilityResult,
        contextKey: attachmentSpecificContextKey,
        enabled: attachmentSpecificContextKey !== null,
        mode: "attachment-specific",
        providerContext: providerContext,
        surface: surface
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b145827b9cdf9663$var$AttachmentActionExtensionProviderState, {
        attachmentActionEligibilityResult: undefined,
        contextKey: unconditionalContextKey,
        enabled: true,
        mode: "unconditional",
        providerContext: providerContext,
        surface: surface
    }, children);
};
function $b145827b9cdf9663$var$_temp(descriptors_0) {
    return descriptors_0.length > 0;
}
module.exports["useAttachmentActionExtensionContext"] = $b145827b9cdf9663$export$908ca5f3fa9de729;
module.exports["AttachmentActionExtensionProvider"] = $b145827b9cdf9663$export$3201888aa75d93eb;

});

parcelRegister("5Pl0K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");


var $3somt = parcelRequire("3somt");

const $9add288b2f1cb4cc$var$coordinator = new (0, $3somt.AttachmentActionDiscoveryExperienceCoordinator)();
const $9add288b2f1cb4cc$var$settleLease = (lease, status, successReason)=>{
    if (status === 'success') lease.succeed(successReason);
    else if (status === 'failure') lease.fail();
    else lease.abort('access-unavailable');
};
const $9add288b2f1cb4cc$export$60b6627d757260c1 = ({ discoveryKey: discoveryKey, enabled: enabled, participantId: participantId, status: status, successReason: successReason, surface: surface })=>{
    const tracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const leaseRef = (0, $cozmU.useRef)(null);
    const latestOutcomeRef = (0, $cozmU.useRef)({
        status: status,
        successReason: successReason
    });
    latestOutcomeRef.current = {
        status: status,
        successReason: successReason
    };
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !discoveryKey) return;
        const registeredLease = $9add288b2f1cb4cc$var$coordinator.register({
            participantId: participantId,
            surface: surface,
            tracker: tracker
        });
        leaseRef.current = registeredLease;
        const latestOutcome = latestOutcomeRef.current;
        if (latestOutcome.status !== 'loading') $9add288b2f1cb4cc$var$settleLease(registeredLease, latestOutcome.status, latestOutcome.successReason);
        return ()=>{
            registeredLease.abort('unmounted-before-settled');
            if (leaseRef.current === registeredLease) leaseRef.current = null;
        };
    }, [
        discoveryKey,
        enabled,
        participantId,
        surface,
        tracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        const lease = leaseRef.current;
        if (!enabled || !discoveryKey || !lease || status === 'loading') return;
        $9add288b2f1cb4cc$var$settleLease(lease, status, successReason);
    }, [
        discoveryKey,
        enabled,
        status,
        successReason
    ]);
};
module.exports["useAttachmentActionDiscoveryExperience"] = $9add288b2f1cb4cc$export$60b6627d757260c1;

});

parcelRegister("3somt", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $3357a5af4ba8e944$var$DISCOVERY_FAILURE_REASON = 'unexpected-error';
const $3357a5af4ba8e944$var$DISCOVERY_FAILURE_MESSAGE = 'Attachment action discovery failed';
const $3357a5af4ba8e944$var$ABORT_REASONS = {
    'access-unavailable': 'Attachment action discovery access unavailable',
    'unmounted-before-settled': 'Attachment action discovery unmounted before settling'
};
class $3357a5af4ba8e944$var$AttachmentActionDiscoveryExperienceError extends Error {
    constructor(){
        super($3357a5af4ba8e944$var$DISCOVERY_FAILURE_MESSAGE);
        this.name = 'AttachmentActionDiscoveryExperienceError';
    }
}
const $3357a5af4ba8e944$var$getSurface = (wave)=>{
    let surface;
    for (const participant of wave.participants.values()){
        if (surface && surface !== participant.surface) return 'mixed';
        surface = participant.surface;
    }
    return surface ?? 'mixed';
};
const $3357a5af4ba8e944$var$getAttributes = (wave, outcomeReason)=>({
        attachmentActionLocation: 'metadata',
        surface: $3357a5af4ba8e944$var$getSurface(wave),
        ...outcomeReason ? {
            outcomeReason: outcomeReason
        } : {}
    });
class $3357a5af4ba8e944$export$910c9ac38fa8c54e {
    register({ participantId: participantId, surface: surface, tracker: tracker }) {
        let wave = this.waves.get(tracker);
        if (!wave) {
            wave = {
                completed: false,
                participants: new Map(),
                settlementScheduled: false
            };
            this.waves.set(tracker, wave);
            tracker.start({
                name: (0, $irVI7.FORGE_ATTACHMENT_ACTION_DISCOVERY_EXPERIENCE),
                attributes: {
                    attachmentActionLocation: 'metadata',
                    surface: surface
                }
            });
        }
        const registration = (wave.participants.get(participantId)?.registration ?? 0) + 1;
        wave.participants.set(participantId, {
            registration: registration,
            state: {
                status: 'pending'
            },
            surface: surface
        });
        return {
            abort: (reason)=>{
                this.updateParticipant({
                    participantId: participantId,
                    registration: registration,
                    state: {
                        status: 'abort',
                        reason: reason
                    },
                    tracker: tracker,
                    wave: wave
                });
            },
            fail: ()=>{
                this.updateParticipant({
                    participantId: participantId,
                    registration: registration,
                    state: {
                        status: 'failure'
                    },
                    tracker: tracker,
                    wave: wave
                });
            },
            succeed: (reason)=>{
                this.updateParticipant({
                    participantId: participantId,
                    registration: registration,
                    state: {
                        status: 'success',
                        ...reason ? {
                            reason: reason
                        } : {}
                    },
                    tracker: tracker,
                    wave: wave
                });
            }
        };
    }
    updateParticipant({ participantId: participantId, registration: registration, state: state, tracker: tracker, wave: wave }) {
        if (wave.completed || this.waves.get(tracker) !== wave) return;
        const participant = wave.participants.get(participantId);
        if (!participant || participant.registration !== registration || participant.state.status !== 'pending') return;
        wave.participants.set(participantId, {
            ...participant,
            state: state
        });
        this.scheduleSettlement(tracker, wave);
    }
    scheduleSettlement(tracker, wave) {
        if (wave.settlementScheduled) return;
        wave.settlementScheduled = true;
        Promise.resolve().then(()=>{
            wave.settlementScheduled = false;
            this.settle(tracker, wave);
        });
    }
    settle(tracker, wave) {
        if (wave.completed || this.waves.get(tracker) !== wave) return;
        const participants = Array.from(wave.participants.values());
        const hasFailure = participants.some(({ state: state })=>state.status === 'failure');
        if (hasFailure) {
            this.complete(tracker, wave, ()=>{
                tracker.fail({
                    name: (0, $irVI7.FORGE_ATTACHMENT_ACTION_DISCOVERY_EXPERIENCE),
                    error: new $3357a5af4ba8e944$var$AttachmentActionDiscoveryExperienceError(),
                    attributes: $3357a5af4ba8e944$var$getAttributes(wave, $3357a5af4ba8e944$var$DISCOVERY_FAILURE_REASON)
                });
            });
            return;
        }
        if (participants.some(({ state: state })=>state.status === 'pending')) return;
        const abortReason = participants.some(({ state: state })=>state.status === 'abort' && state.reason === 'access-unavailable') ? 'access-unavailable' : participants.some(({ state: state })=>state.status === 'abort') ? 'unmounted-before-settled' : undefined;
        if (abortReason) {
            this.complete(tracker, wave, ()=>{
                tracker.abort({
                    name: (0, $irVI7.FORGE_ATTACHMENT_ACTION_DISCOVERY_EXPERIENCE),
                    reason: $3357a5af4ba8e944$var$ABORT_REASONS[abortReason],
                    attributes: $3357a5af4ba8e944$var$getAttributes(wave, abortReason)
                });
            });
            return;
        }
        const successReason = participants.some(({ state: state })=>state.status === 'success' && state.reason === 'invalid-descriptor') ? 'invalid-descriptor' : undefined;
        this.complete(tracker, wave, ()=>{
            tracker.succeed({
                name: (0, $irVI7.FORGE_ATTACHMENT_ACTION_DISCOVERY_EXPERIENCE),
                attributes: $3357a5af4ba8e944$var$getAttributes(wave, successReason)
            });
        });
    }
    complete(tracker, wave, stop) {
        wave.completed = true;
        this.waves.delete(tracker);
        stop();
    }
    constructor(){
        this.waves = new WeakMap();
    }
}
module.exports["AttachmentActionDiscoveryExperienceCoordinator"] = $3357a5af4ba8e944$export$910c9ac38fa8c54e;

});


//# sourceMappingURL=AttachmentsMacroRenderer.05513b95.js.map
